import Caption from "components/Caption";
import { Typography, LinearProgress } from "@mui/material";
import { calcColorFromTheme } from "helpers/calcColor";
import theme from "theme";

interface ProgressBarProps {
  text?: string;
  value: number;
  showBar?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium";
}
const ProgressBar = (props: ProgressBarProps) => {
  const { value, text } = props;
  const size = props.size ? props.size : "medium";

  const showBar = props.showBar === undefined ? true : props.showBar;

  return (
    <div>
      {text && <Caption bold text={text} />}
      {showBar && (
        <LinearProgress
          variant="determinate"
          sx={{
            borderRadius: 1,
            marginTop: 1,
            maxWidth: props.fullWidth ? undefined : "100px",
          }}
          classes={{
            colorPrimary: theme.palette.grey.A100,
            barColorPrimary: calcColorFromTheme(theme, props.value),
          }}
          value={value}
        />
      )}
      <Typography
        variant={size === "small" ? "body1" : "h6"}
        sx={{
          color: calcColorFromTheme(theme, props.value),
        }}>
        {value.toFixed(1).toString()}%
      </Typography>
    </div>
  );
};

export default ProgressBar;
